import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BUYER_CARD_BASE_URL, REACT_APP_API_MY_INSTITUTION_URL } from '../config/settings/environment'
import { CLAIMS_OPTIONS_DICTIONARY } from '../config/settings/constant'

/**
 * Get claims pieChart.
 */
export const getClaimsChart = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BUYER_CARD_BASE_URL}/reclamos/calculos_reclamos?rut=${dni}`)
})

/**
 * Get claims table information.
 */
export const getClaimsTable = factoryService(({ dni, type }) => {
  const typeParam = type === CLAIMS_OPTIONS_DICTIONARY.all ? '' : `&type=${type}`
  return getJsonRequest(`${REACT_APP_API_BUYER_CARD_BASE_URL}/reclamos/detalle_reclamos?rut=${dni}${typeParam}`)
})

/**
 * Gets encrypt Claim
 */
export const getEncryptClaim = factoryService(({ claimId }) => {
  return getJsonRequest(`${REACT_APP_API_MY_INSTITUTION_URL}/v1/mi-institucion/encrypt/reclamo/${claimId}`)
})
